module.exports = __webpack_public_path__ + "img/gywm-2.bbf0bef7.jpg";